<template>
  <div class="colors-list">
    <ai-clear-button @click="onColorPickerBtnClick" id="colors-list-activator" class="colors-list__btn">
      <inline-svg class="colors-list__indicator__cleared__icon" :src="require('@/assets/icons/plus.svg')"> </inline-svg>
    </ai-clear-button>
    <div class="colors-list__btn" :class="{ 'colors-list__btn--selected': !selectedColorId }">
      <ai-clear-button @click="resetHandler" class="colors-list__btn__inner">
        <img :src="require('@/assets/icons/editor/removeBg.svg')" alt="" />
      </ai-clear-button>
    </div>
    <div v-for="color in computedColors" class="colors-list__option" :key="color.id">
      <div
        :style="{ backgroundColor: color.color }"
        :class="{ 'colors-list__btn--selected': selectedColorId === color.id }"
        class="colors-list__btn"
      >
        <ai-clear-button @click="selectColor(color)" class="colors-list__btn__inner" />
      </div>
      <!-- <ai-clear-button @click="removeColor(color.color)">
        <v-icon color="white" class="products-item__icons-sizing">mdi-delete-outline</v-icon>
      </ai-clear-button> -->
    </div>
  </div>

  <v-menu activator="#colors-list-activator" :close-on-content-click="false">
    <color-picker
      v-click-outside="onColorPickerOutsideClick"
      @color-change="updateColor"
      style="color: black; background-color: white"
      id="colors-list__inputs-picker"
      class="colors-list__inputs-picker"
      :color="colorValue ? colorValue : '#c52323'"
      :visible-formats="['hex', 'rgb']"
      default-format="hex"
      alpha-channel="hide"
    />
  </v-menu>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { uniqueId } from 'lodash';
import i18n from '@/plugins/i18n';
import AiClearButton from '@/components/UI/AiClearButton/AiClearButton.vue';
import { storeToRefs } from 'pinia';
import { useEditorStore } from '@/store/editor';

interface IColor {
  id: string;
  color: string;
}

const props = defineProps<{ modelValue: string | null }>();

const { generateImageData } = storeToRefs(useEditorStore());
const emit = defineEmits(['update:modelValue']);
const selectedColorId = ref<string | null>(null);
const isColorPickerVisible = ref<boolean>(false);
const colors = ref<IColor[]>([]);

const colorValue = computed({
  get() {
    return props.modelValue;
  },
  set(newVal) {
    emit('update:modelValue', newVal);
  },
});
const computedColors = computed(() => {
  const resultColors = [...colors.value];
  // const resColorIndex = colors.value.findIndex((color: IColor) => color.color === colorValue.value);
  // if (resColorIndex === -1 && colorValue.value) {
  //   resultColors.splice(0, 1);
  //   resultColors.unshift({
  //     id: '111111',
  //     color: colorValue.value,
  //   });
  reAssignSelectedColor();
  // }
  return resultColors;
});

const selectColor = (color: IColor | null): void => {
  selectedColorId.value = color?.id || null;
  if (!color) {
    resetHandler();
  } else {
    emit('update:modelValue', color.color);
  }
};

const valueToHex = (c: number): string => {
  const hex = c.toString(16);
  return hex;
};
const rgbToHex = (r: number, g: number, b: number): string => valueToHex(r) + valueToHex(g) + valueToHex(b);

const updateColor = (eventData: any): void => {
  const { cssColor } = eventData;
  const isRgb = cssColor.startsWith('rgb');

  if (!isRgb) {
    colorValue.value = cssColor;
    return;
  }

  const rgbColors = cssColor
    .substring(4, cssColor.length - 1)
    .split(' ')
    .map((item: string) => Math.round(parseFloat(item)));

  const hexValue = rgbToHex(rgbColors[0], rgbColors[1], rgbColors[2]);
  colorValue.value = `#${hexValue}`;
};
function onColorPickerBtnClick(): void {
  isColorPickerVisible.value = !isColorPickerVisible.value;
  // if (!isColorPickerVisible.value) emitDifference();
  if (!isColorPickerVisible.value) return;
  const txt = i18n.global.t('apply');
  setTimeout(() => {
    const colorPicker = document.querySelector('.color-picker__inputs-picker');
    if (!colorPicker) return;
    const btn = document.createElement('button');
    const btnText = document.createTextNode(txt);
    btn.appendChild(btnText);
    btn.classList.add('btn-apply');
    colorPicker.appendChild(btn);
    btn.addEventListener('click', () => {
      const activator = document.querySelector('#color-picker-activator') as HTMLElement;
      activator?.click();
    });
  }, 5);
}

const onColorPickerOutsideClick = (): void => {
  if (isColorPickerVisible.value === false) return; // if click happened onColorPickerBtnClick
  isColorPickerVisible.value = false;
  emitDifference();
};

const emitDifference = (): void => {
  if (colorValue.value === '') {
    return;
  }
  const id = uniqueId('color-');
  emit('update:modelValue', colorValue.value);
  if (colorValue.value) {
    colors.value.unshift({ color: colorValue.value, id });
    colors.value = colors.value.splice(0, 4);
  }
};

const resetHandler = (): void => {
  selectedColorId.value = null;
  emit('update:modelValue', '');
};
const reAssignSelectedColor = (): void => {
  const tmpSelectedColorIndex = colors.value.findIndex((color: IColor) => color.color === props.modelValue);
  if (tmpSelectedColorIndex !== -1) {
    selectedColorId.value = colors.value[tmpSelectedColorIndex]?.id;
  }
};

onMounted(async () => {
  if (generateImageData.value?.color) {
    colors.value.push({ color: generateImageData.value.color, id: '1234' });
  }
  if (props.modelValue !== '' && props.modelValue !== null) {
    reAssignSelectedColor();
  }
});
</script>

<style scoped lang="scss" src="./ColorsList.scss" />
